import $ from "jquery";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import utils from '../utils';
let { isMobile, onSwipe, Wheel, isTouchDevice, isTabletSm, isPortrait } = utils;

function snap() {
    let isScrolling = false;
    let isHero = true;
    let counter = 0;
    let currentPosition = 0;

    lscroll.stop();

    // const snapTrigger = ScrollTrigger.create({
    //     scroller: "[data-scroll-container]",
    //     trigger: document.querySelector('#section--1'),
    //     scrub: 0,
    //     start: "top bottom",
    //     end: "top top",
    //     onEnterBack: self => {
    //         console.log( 'sstop');
    //         isHero = true;
    //         lscroll.stop();
    //     },
    //     pinSpacing: false,
    //     markers: false,
    // } );

    let hero = document.querySelector('.hero');

    let options = {
        onUp: function(){
            onScrollEnd('down')
        },
        onDown: function(){
            onScrollEnd('up')
        }
    };

    document.addEventListener("preloaderDone", () => {
        console.log(11);
        console.log(isTouchDevice);
        if(isTouchDevice) {
        console.log(22);

            var handleSwipe = new onSwipe(hero, options);
        } else {
        console.log(33);

            let handleWheel = new Wheel(hero, options);
        }
    },{ once: true });

    function onScrollEnd(direction) {
        let sectionHeight = document.querySelector('#hero-point-1').offsetHeight;
        let canvas = document.querySelector('.hero-video-holder canvas');

        let xDays = {
          1: 0.8476477683956574,
          2: 0.9237635705669481
        }

        if(direction == 'down' && !isScrolling && isHero) {

            if(counter < 11) {
                isScrolling = true;
                counter++;
                let nextPoint = document.querySelector(`#hero-point-${counter}`);
                let offsetTop = nextPoint.offsetTop;

                if(isPortrait) {
                    if(counter == 9) {
                        offsetTop = ($('.hero').outerHeight()-window.innerHeight) * xDays[1] + 45
                    }
    
                    if(counter == 10) {
                        offsetTop = ($('.hero').outerHeight()-window.innerHeight) * xDays[2] + 45
                    }
                }

                let duration = 1000 * (Math.abs(offsetTop - currentPosition)/sectionHeight);
                
                // setTimeout(() => {
                //     if(!nextPoint.hasAttribute('data-keep-bg')) canvas.classList.remove('-opacity');
                // }, 200)

                // setTimeout(() => {
                //     canvas.classList.add('-opacity');
                // }, duration - 400)
    
                lscroll.scrollTo(offsetTop, {
                    // duration: 1500,
                    duration: duration,
                    offset: isMobile || isTabletSm || isPortrait ? -45 : -30,
                    callback: () => {
                        currentPosition = offsetTop;
                        isScrolling = false;
                    }
                })
            } else {
                lscroll.start();
                  console.log('lscroll.start')

                isHero = false;
            }
        }

        if(direction == 'up' && !isScrolling && counter > 0 && isHero) {

            isScrolling = true;
            counter--;                
            let nextPoint = document.querySelector(`#hero-point-${counter}`);
            let offsetTop = nextPoint.offsetTop;

            if(isPortrait) {
                if(counter == 9) {
                    offsetTop = ($('.hero').outerHeight()-window.innerHeight) * xDays[1] + 45
                }

                if(counter == 10) {
                    offsetTop = ($('.hero').outerHeight()-window.innerHeight) * xDays[2] + 45
                }
            }

            //transform:scale(0.43) translate(calc(-0.88 * (742px - 60px)), -1%);
            //scale(0.43) translate(calc(-0.88 * (var(--win-height) - 60px)), -1%);

            let duration = 1000 * (Math.abs(offsetTop - currentPosition)/sectionHeight);
                
            setTimeout(() => {
                if(!nextPoint.hasAttribute('data-keep-bg')) canvas.classList.remove('-opacity');
            }, 200)

            setTimeout(() => {
                canvas.classList.add('-opacity');
            }, duration - 400)

            lscroll.scrollTo(offsetTop, {
                // duration: 1500,
                duration: duration,
                offset: isMobile || isTabletSm || isPortrait ? -45 : -30,
                callback: () => {
                    currentPosition = offsetTop;
                    isScrolling = false;
                }
            })
        }
    }
}

export default function() {
    document.querySelectorAll('[data-snap]').forEach(element => {
        snap();
    });
}